import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { companySignin, authentication } from '../actions/auth';
import './CompanySignin.css';

const CompanySignin = () => {
    const history = useHistory();
    const [values, setValues] = useState({
        email: '',
        password: '',
        loading: false,
        error: '',
        showPassword: false,
    });

    const { email, password, loading, error, showPassword } = values;

    const handleChange = (name) => (e) => {
        setValues({ ...values, error: '', [name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setValues({ ...values, loading: true });

        companySignin({ email, password }).then((data) => {
            if (data.err) {
                setValues({ ...values, error: data.err, loading: false });
            } else {
                authentication(data, () => {
                    // Company user - redirect to company dashboard
                    history.push('/admin/company-dashboard');
                });
            }
        });
    };

    return (
        <div className="company-signin">
            {/* Animated Background */}
            <div className="signin-background">
                <div className="gradient-orb orb-1"></div>
                <div className="gradient-orb orb-2"></div>
                <div className="gradient-orb orb-3"></div>
            </div>

            {/* Main Content */}
            <div className="signin-container">
                {/* Left Side - Branding */}
                <div className="signin-branding">
                    <div className="brand-content">
                        <h1 className="brand-title">
                            Welcome to <span className="highlight">InfoEthiopia</span>
                        </h1>
                        <p className="brand-subtitle">
                            Your gateway to Ethiopia's premier business directory
                        </p>
                        <div className="brand-features">
                            <div className="feature-item">
                                <div className="feature-icon">📰</div>
                                <span>Manage Your News</span>
                            </div>
                            <div className="feature-item">
                                <div className="feature-icon">💼</div>
                                <span>Post Job Opportunities</span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Right Side - Sign In Form */}
                <div className="signin-form-section">
                    <div className="form-card">
                        <div className="form-header">
                            <h2>Sign In</h2>
                            <p>Enter your credentials to access your account</p>
                        </div>

                        {error && (
                            <div className="error-message">
                                <span className="error-icon">⚠️</span>
                                {error}
                            </div>
                        )}

                        <form onSubmit={handleSubmit} className="signin-form">
                            <div className="form-group">
                                <label htmlFor="email">Email Address</label>
                                <div className="input-wrapper">
                                    <span className="input-icon">✉️</span>
                                    <input
                                        type="email"
                                        id="email"
                                        value={email}
                                        onChange={handleChange('email')}
                                        placeholder="your@email.com"
                                        required
                                    />
                                </div>
                            </div>

                            <div className="form-group">
                                <label htmlFor="password">Password</label>
                                <div className="input-wrapper">
                                    <span className="input-icon">🔒</span>
                                    <input
                                        type={showPassword ? 'text' : 'password'}
                                        id="password"
                                        value={password}
                                        onChange={handleChange('password')}
                                        placeholder="Enter your password"
                                        required
                                    />
                                    <button
                                        type="button"
                                        className="toggle-password"
                                        onClick={() =>
                                            setValues({ ...values, showPassword: !showPassword })
                                        }
                                    >
                                        {showPassword ? '👁️' : '👁️‍🗨️'}
                                    </button>
                                </div>
                            </div>

                            <div className="form-options">
                                <label className="remember-me">
                                    <input type="checkbox" />
                                    <span>Remember me</span>
                                </label>
                                <a href="/staff/forgot-password" className="forgot-password">
                                    Forgot Password?
                                </a>
                            </div>

                            <button type="submit" className="signin-button" disabled={loading}>
                                {loading ? (
                                    <>
                                        <span className="spinner"></span>
                                        Signing In...
                                    </>
                                ) : (
                                    'Sign In'
                                )}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CompanySignin;
